<template lang="pug">
//- NOTICE: deprecated
//iframe(height="0", width="0", style="display:none", :src="this.$user.loginUrl")
</template>

<script>

import { navigation } from './navigation'

// Get avalable sitemap
// and asume all sections/components are allowed
import tabs from '@/core/site-map/map.json'
const allowedComponents = tabs

// NOTICE: deprecated
const resolveUser = (data) => {
  /** Set payload as form-data */
  var formData = new FormData()
  formData.append('user', data.username)
  formData.append('pass', data.password)

  return new Promise((resolve, reject) => {
    this.api.post(this.api.$.login, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then((response) => {
      response.data.login = this.api.$.Login + response.data.sk
      response.data.email = response.data.username

      resolve(response.data)
    }).catch(() => reject)
  })
}

const getModules = () => {
  const authUser = JSON.parse(window.localStorage.getItem('evedUser'))
  var modules = []

  if (authUser && authUser.token && authUser.modules) {
    modules = authUser.modules
  }

  return modules
}

const getPermissions = () => {
  const authUser = JSON.parse(window.localStorage.getItem('evedUser'))
  var permissions = []

  if (authUser && authUser.token && authUser.permissions) {
    permissions = authUser.permissions
  }

  return permissions
}

export default {
  name: 'legacy-auth',

  created() {
    const authUser = JSON.parse(window.localStorage.getItem('evedUser'))

    if (authUser && authUser.token) {
      this.$user.email = authUser.user.Email
    }
  },

  resolveUser: resolveUser,

  allowedComponents,

  allowedModules: () => {
    // if (this.default.allowedModules.get) return

    const user = JSON.parse(window.localStorage.getItem('evedUser'))

    var modules = {}
    var menus = getModules()

    console.info('Allowed modules init')

    Object.keys(tabs).forEach((v, k) => {
      // if (v === '_modules') return
      if (check(v)) {
        modules[v] = {
          label: tabs[v].alias || tabs,
          alias: tabs[v].label,
          autoHideSubtabs: tabs[v].autoHideSubtabs,
          subtabs: {}
        }

        let subtabs = menus[tabs[v].alias || tabs[v]]

        // keep Programs menu label for Buyer/Seller
        if (modules[v].label === 'Commerce' && Number(user.domain) === 2) {
          modules[v].alias = 'Programs'
        }

        if (tabs[v].subtabs) {
          subtabs = Object.assign({}, subtabs, tabs[v].subtabs)
        }

        menus.length !== 0 && Object.keys(subtabs).forEach((vs, i) => {
          if ((typeof subtabs[vs].domain === 'undefined') || (subtabs[vs].domain.indexOf(parseInt(user.domain)) > -1)) {
            modules[v].subtabs[vs] = subtabs[vs].alias || subtabs[vs]
          }
        })

        // While filtering out navigation based on user permissions
        // also mark sections/components in the sitemap
        if (tabs[v].pack) {
          let pack = tabs[v].pack
          let allowed = modules[v].subtabs
          let allowedFlat = []

          allowed && Object.keys(allowed).forEach(k => allowedFlat.push(allowed[k]))

          Object.keys(pack).forEach(k => {
            if (typeof pack[k].name === 'string' || typeof pack[k] === 'string') {
              const name = pack[k].name || pack[k]
              allowedComponents[v].pack[k] = {
                name: name,
                notAllowed: !~allowedFlat.indexOf(k)
              }
            }
          })
        }
      }
    })

    function check(tab) {
      const user = JSON.parse(window.localStorage.getItem('evedUser'))
      const permissions = getPermissions()

      if ((typeof tabs[tab].domain !== 'undefined') && !~tabs[tab].domain.indexOf(parseInt(user.domain))) {
        return false
      }

      let result = true
      let skip = false

      if (typeof tabs[tab].allow !== 'undefined') {
        Object.keys(tabs[tab].allow).forEach((v, k) => {
          if (!~permissions.indexOf('deny' + v)) {
            if (tabs[tab].allow[v] === 'any') {
              result = true
              skip = true
            }

            if (tabs[tab].allow[v] === 'none') {
              result = false
              skip = true
            }
          } else if (!skip && tabs[tab].allow[v] === 'all') {
            result = false
          }
        })
      }

      if (!skip) {
        if ((typeof tabs[tab].subscription !== 'undefined') && (tabs[tab].subscription !== user.subscription)) {
          result = false
        }
      }

      return result
    }

    modules = navigation({...modules})

    console.info('You have access to', modules)

    const defaultKey = Object.keys(this)[0]

    this[defaultKey].allowedModules.get = modules
    return modules
  }
}

</script>



// WEBPACK FOOTER //
// src/core/legacy-auth/index.vue